import { render, staticRenderFns } from "./dashboard_welcome.vue?vue&type=template&id=ec4bcedc&scoped=true&"
import script from "./dashboard_welcome.vue?vue&type=script&lang=js&"
export * from "./dashboard_welcome.vue?vue&type=script&lang=js&"
import style0 from "./dashboard_welcome.vue?vue&type=style&index=0&id=ec4bcedc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4bcedc",
  null
  
)

export default component.exports